<script>
  import { onMount, onDestroy } from "svelte";
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  import Paragraphs from './paragraphs.svelte';
  
  const defaultArticle = {name: 'x', opened: false,
                          paragraphs: [
                              {name: '', content: 'xdddxx'}
                          ]};
  
  let articles = [Object.assign({}, defaultArticle)];
  
  onMount(() => {
  })
  
  export function dragstart(e) {
    let article = articles[parseInt(e.target.getAttribute('index'))]
    var component = {
      type: "article",
      name: article.name,
      paragraphs: article.paragraphs
    }
    e.dataTransfer.setData("text/plain", JSON.stringify(component));
  }
</script>
<div class='list-item-group'>
{#each articles as {name, paragraphs, opened}, i}
<article class='list-item' draggable='true' index='{i}' on:dragstart='{event => dragstart(event)}' target='_blank'>
<h2 class='d-flex justify-content-between'>
<input bind:value='{name}' class='d-inline ui pl-1' type='text'>
<button class='btn btn-link' on:click|preventDefault='{() => opened = !opened}'>
<i class:fa-angle-double-down='{!opened}' class:fa-angle-double-up='{opened}' class='fas'></i>
</button>
</h2>
{#if opened}
<Paragraphs article='{articles[i]}'></Paragraphs>
{/if}
</article>
{/each}
</div>
